/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Einvoice_Publish_UnknownInputs */

const vi_einvoice_publish_unknown = /** @type {(inputs: Einvoice_Publish_UnknownInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`MISA chưa trả kết quả phát hành. Hệ thống tự kiểm tra lại vài phút một lần; bạn có thể làm tiếp đơn khác. Không bấm phát hành lại đơn này.`)
};

/**

* @param {Einvoice_Publish_UnknownInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const einvoice_publish_unknown = /** @type {((inputs?: Einvoice_Publish_UnknownInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Einvoice_Publish_UnknownInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_einvoice_publish_unknown(inputs)
});